import { Component } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import {NgbAlertConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-inscripcion',
  templateUrl: './inscripcion.component.html',
  styleUrls: ['./inscripcion.component.css'],
  styles: [`
      .ng-invalid.ng-touched:not(form) {
        border: 1px solid red;
      }
    `]
})
export class InscripcionComponent {

  formulario: any = {
    dni: '',
    nombre: '',
    apellido: '',
    correo: '',
    claustro: '',
    especifica: '',
    aceptaTerminos: false,
    resultado: ''
  };

  claustros = [{
    valor: '1',
    nombre: 'Estudiante'
    },
    {
      valor: '2',
      nombre: 'Docente'
    },
    {
      valor: '3',
      nombre: 'Personal Apoyo'
    },
    {
      valor: '4',
      nombre: 'Egresada/o'
    },
    {
      valor: '5',
      nombre: 'Organización Universitaria'
    },
    {
      valor: '6',
      nombre: 'Movimiento Social Local'
    },
    {
      valor: '7',
      nombre: 'Institución Pública'
    },
    {
      valor: '8',
      nombre: 'Otras organizaciones'
    }];

  alerta: any = {
    exito: false,
    cuposCompletos: false,
    personaRegistrada: false,
    info: ''
  };
  procesar: boolean;

  constructor(private http: HttpClient) {  }

  inscribirse(formulario) {
    const msj = 'Error al inscribirse';
    const body = JSON.stringify(  { 'dni': formulario.dni, 'nombre': formulario.nombre, 'apellido': formulario.apellido, 'correo': formulario.correo, 'claustro': formulario.claustro, 'especifica': formulario.especifica } );

    const promise = new Promise((resolve, reject) => {
    this.procesar = true;
    const apiURL = 'https://citsistemas3.uncu.edu.ar/idegem/1.0/?ai=idegem||33705149000010';
      this.http.post(apiURL, body)
        .subscribe(
          (res: any) => {
            // console.log(res);
            this.procesar = false;
            if (res['cupos'] != 'Cupo completado') {
              this.getCodigoAut();
              this.alerta.exito = true;
              this.alerta.info = 'Gracias por apoyarnos con su Firma';
              this.formulario = {
                dni: '',
                nombre: '',
                apellido: '',
                correo: '',
                claustro: '',
                aceptaTerminos: false,
                resultado: ''
              };
            } else {
              this.alerta.cuposCompletos = true;
              this.alerta.info = 'Convocatoria de Firmas Finalizada';
              this.formulario.resultado = '';
            }
          },
          msg => {
            reject(msj);
            this.procesar = false;
            this.alerta.personaRegistrada = true;
            this.alerta.info = 'Ya se ha registrado una Firma con este DNI';
          });
    });
    this.alerta = {
      exito: false,
      cuposCompletos: false,
      personaRegistrada: false,
      info: ''
    };
    return promise;
  }

  getCodigoAut() {
      const msjError = 'Error al consultar codigo';
      const promise = new Promise((resolve, reject) => {
        const apiURL = 'https://citsistemas3.uncu.edu.ar/idegem/1.0/?ai=idegem||33705149000013';
        this.http.get(apiURL, {})
          .subscribe(
            (res: any) => {
              this.formulario.resultado = 'Codigo de autentificación: ' + res.codigo_autentif;
            },
            msg => {
              console.log(msjError);
              reject(msjError);
            });
      });
      return promise;
    }

}
